module.exports = __webpack_public_path__ + "img/video-cards.c880ceeb.png";